<template>
  <b-tab>
    <template #title>
      <span>Servicios</span>
      <b-badge variant="dark" class="ml-2">{{ numServicios }}</b-badge>
    </template>

    <!-- Servicios: Forma Pago y Descuento -->
    <b-row class="mb-4">
      <b-col lg="6">
        <campo-modalidad-pago :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId" />
      </b-col>
      <b-col lg="6">
        <campo-descuento
          label="Descuento servicios"
          :tipos-descuento="tiposDescuentoParaServicios"
          v-model="oferta.tipoDescuentoServicios"
          :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId"
        />
      </b-col>
    </b-row>

    <selector-servicios v-show="borrador" :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId" />
    <tabla-servicios-oferta :disabled="ofertaBloqueada || !oferta.divisaId || !oferta.planId" />
    <detalle-valoracion-servicios />
  </b-tab>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import SelectorServicios from "./EditorModulos/SelectorServicios";
import TablaServiciosOferta from "./EditorModulos/TablaServiciosOferta";
import CampoModalidadPago from "./CamposOferta/CampoModalidadPago";
import CampoDescuento from "./CamposOferta/CampoDescuento";
import DetalleValoracionServicios from "./DetalleValoracionServicios";

export default {
  components: {
    SelectorServicios,
    TablaServiciosOferta,
    CampoModalidadPago,
    CampoDescuento,
    DetalleValoracionServicios,
  },
  computed: {
    ...mapState(useOfertaFormStore, ["borrador", "numServicios", "oferta", "tiposDescuentoParaServicios"]),
    ofertaBloqueada() {
      return this.oferta.caducada == 1 || this.oferta.borrador == 0;
    },
  },
};
</script>
